/* eslint-disable i18next/no-literal-string */
import cn from 'classnames'
import s from './FormInput.module.scss'
import React, { ChangeEvent, InputHTMLAttributes } from 'react'
import { OpenEye, ClosedEye } from '@components/icons'

export interface Props extends InputHTMLAttributes<HTMLInputElement> {
    name: string
    error?: string
    className?: string
    variant?: 'line'
    touched?: boolean
    type?: string
    onChange?: (...args: any[]) => any
}

const FormInput: React.FC<Props> = ({
    className,
    error,
    variant,
    touched = true,
    type,
    name,
    id,
    onChange,
    ...rest
}) => {
    const [isPasswordDisplayed, setIsPasswordDisplayed] = React.useState(false)

    const isInputPassword =
        type === 'password' || name.toLocaleLowerCase() === 'password'
    const inputType = isInputPassword && isPasswordDisplayed ? 'text' : type

    const rootClassName = cn(
        s.root,
        `appearance-none w-full border-b ${
            error ? 'border-alert-danger' : 'border-p-7'
        } px-0 mb-2 focus:shadow-none focus:outline-none focus-visible:border-b focus-visible:shadow-none`,
        s.formInput,
        className
    )

    const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(e.target.value, e)
        }
    }

    return (
        <div className={cn(s.inputContainer, variant === 'line' && s.line)}>
            <input
                className={rootClassName}
                onChange={handleOnChange}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                placeholder=" "
                type={inputType}
                id={id}
                {...rest}
            />
            <label htmlFor={id} className={s.label}>
                {name}
            </label>

            {isInputPassword && (
                <button
                    onClick={() => setIsPasswordDisplayed((prev) => !prev)}
                    type="button"
                    className={s.eyeIcon}
                >
                    {isPasswordDisplayed ? (
                        <ClosedEye aria-label="closed eye" />
                    ) : (
                        <OpenEye aria-label="opened eye" />
                    )}
                </button>
            )}
            {error && touched && (
                <span className="text-alert-danger text-xs leading-4 font-normal">
                    {error}
                </span>
            )}
        </div>
    )
}

export default FormInput
